/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const FocusListIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 71"
    onClick={props.onClick}
  >
    <g fill="none">
      <g strokeWidth="2">
        <path d="M1.5 69.5h69M13.5 69.5v-9h-9v9M31.5 69.5v-21h-9v21M49.5 69.5v-33h-9v33M67.5 69.5v-45h-9v45M9 39.5l54-36M61.5 15.5l1.5-12L51 2" />
      </g>
    </g>
  </svg>
);

export default FocusListIcon;
